module.exports = __webpack_public_path__ + "media/images/area/icon_weather_8-593b37f882dca47fbc816d0312864e74.png";